// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__aL02t","savePackageButton":"ClientWallet_savePackageButton__2h0g6"};